import React, { useCallback, useEffect, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/table';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/code';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/advlist';
import 'tinymce/skins/ui/oxide/skin.min.css';
import HELPERS from 'utils/helper';
import {debounce} from "lodash";
import AUTH_API from "api/auth";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";
import { selectStepReflections, updateStepReflection } from 'slices/dashboardSlice';

const TinyEditor = ({ externalValue, stepId, stepKey }) => {
  const [editorData, setEditorData] = useState(externalValue || "");
  const userId = HELPERS.getUserId()
  const dispatch = useDispatch();
  const stepReflections = useSelector(selectStepReflections);

  useEffect(() => {
    // const payload = {
    //   stepId: stepId,
    //   stepKey: stepKey,
    //   userId: userId,
    // };
    AUTH_API.getEditorData(stepId)
    .then((resp) => {
      if (resp && resp.data) {
        HELPERS.log("sss Editor data fetched", resp.data);
        // message.success("Data fetched")
        setEditorData(resp.data.editor_data || '');
      }
    }).catch((err) => {
      HELPERS.log("sss Error fetching editor data", err);
      // message.error("Data not fetched")
    });
  }, [stepId]);

  const patchTextEditor = useCallback(
    debounce((content) => {
      const payload = {
        editor_data: content,
        stepId: stepId,
        stepKey: stepKey,
        userId: userId,
      };
      console.log('sss Auto-saving', payload, content)
      AUTH_API.patchTextEditor(payload, stepId)
      .then((response) => {
        console.log("sss patch res", response);
        message.success("Your work has been saved")
      })
      .catch((err) => {
        message.error("Your work is not saved")
        console.log("sss not patched", err);
      });

      if( stepReflections[stepKey].status === 'UN' ){

        const action = 'ON'
        const data = {
          id: stepId,
          step: stepKey,
          status: action,
          flag: action === "LO" ? false : true
        };
  
        AUTH_API.CoachStepsPatch(data, stepId)
        .then((response) => {
          console.log("patch api response", response)
          if (response && response.data) {
            dispatch(
              updateStepReflection({
                stepKey: stepKey,
                data: { status: response.data.status }
              })
            );
          }
        })
        .catch((err) => {
          console.log("patch api error", err)
        });

        if(stepKey === 'NN'){
          const data = {
            id: stepReflections["PI"].id,
            step: "PI",
            status: action,
            flag: action === "LO" ? false : true
          };
    
          AUTH_API.CoachStepsPatch(data, stepReflections["PI"].id)
          .then((response) => {
            console.log("patch api response", response)
            if (response && response.data) {
              dispatch(
                updateStepReflection({
                  stepKey: "PI",
                  data: { status: response.data.status }
                })
              );
            }
          })
          .catch((err) => {
            console.log("patch api error", err)
          });
        }
      }
    }, 1000), // Debounce delay of 2 second
    [stepId, stepKey]
  );

  useEffect(() => {
    return () => {
      patchTextEditor.cancel();
    };
  }, [patchTextEditor]);

  const updateAndSaveValue = (data) => {
    setEditorData(data); 
    console.log('sss Editor', data)
    patchTextEditor(data);
  }

  return (
    <>
      <Editor
        value={editorData}
        onEditorChange={updateAndSaveValue}
        init={{
          menubar: false,
          content_style: `
            @font-face {
              font-family: 'AvenirBook';
              src: url('https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/Avenir-Medium-09.ttf') format('truetype');
              font-weight: normal;
              font-style: normal;
            }
            .mce-content-body {
              font-family: 'AvenirBook';
              font-weight: 500;
            }
            .mce-content-body strong, .mce-content-body b {
              font-weight: 900;
              /*letter-spacing: -0.2px;*/
              -webkit-text-stroke: 0.2px;
            }
            body {
              font-family: 'AvenirBook';
              font-size: 16px;
            }
            table {
              width: 98%;
            }
            table, th, td {
              border: 1px solid #ccc;
              border-collapse: collapse;
            }
            th, td {
              padding: 5px;
            }
            td p {
              margin-top: 0;
              margin-bottom: 0;
            }
            p {
              font-family: 'AvenirBook';
            }
            .ephox-snooker-resizer-cols.ephox-snooker-resizer-bar {
              cursor: col-resize;
            }
            .ephox-snooker-resizer-rows.ephox-snooker-resizer-bar {
              cursor: row-resize;
            }
          `,
          plugins: [
            'advlist lists',
            'insertdatetime table paste'
          ],
          // toolbar: 'undo redo | formatselect fontselect fontsizeselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table | removeformat | help',
          toolbar: 'undo redo | formatselect fontsizeselect | bold italic underline| table | bullist numlist outdent indent',   
          fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 30pt 36pt 40pt',
          table_resize_bars: true,
          table_resizable: true,
          branding: false,
          resize: false,
          paste_preprocess: (plugin, args) => {
            const bottomSpacing = '<p>&nbsp;</p><p>&nbsp;</p>';
            args.content = `${args.content}${bottomSpacing}`;
          },
          table_default_attributes: {
            style: ''
          },
          toolbar_sticky: true,
        }}
        />
    </>
  );
};

export default TinyEditor;